import request from '@/utils/request'

let VisiterApi = {

  /*拜访记录列表*/
  list(data) {
    return request._post('/shop/plus.visiter.Index/index', data);
},
/*添加拜访记录*/
add(data) {
    return request._post('/shop/plus.visiter.Index/add', data);
},
/*修改拜访记录*/
edit(data) {
    return request._post('/shop/plus.visiter.Index/edit', data);
},
/*删除拜访记录*/
del(data) {
    return request._post('/shop/plus.visiter.Index/del', data);
},
/*拜访记录详情*/
detail(data) {
  return request._post('/shop/plus.visiter.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.visiter.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.visiter.Setting/getSetting', data, errorback);
    },
}
export default VisiterApi;



// WEBPACK FOOTER //
// ./src/api/visiter.js